import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const SearchIcon: FC<IconProps> = ({ size = 24, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M16.0686 15.0943H17.1527L24 21.9554L21.9554 24L15.0943 17.1527V16.0686L14.7238 15.6844C13.1595 17.0292 11.1286 17.8388 8.91938 17.8388C3.99314 17.8388 0 13.8456 0 8.91938C0 3.99314 3.99314 0 8.91938 0C13.8456 0 17.8388 3.99314 17.8388 8.91938C17.8388 11.1286 17.0292 13.1595 15.6844 14.7238L16.0686 15.0943ZM2.74443 8.91938C2.74443 12.3362 5.50257 15.0943 8.91938 15.0943C12.3362 15.0943 15.0943 12.3362 15.0943 8.91938C15.0943 5.50257 12.3362 2.74443 8.91938 2.74443C5.50257 2.74443 2.74443 5.50257 2.74443 8.91938Z'
          fill={color} />

  </svg>
)

export default SearchIcon
